import { render, staticRenderFns } from "./bindMobile.vue?vue&type=template&id=a70c357a&scoped=true&"
import script from "./bindMobile.vue?vue&type=script&lang=js&"
export * from "./bindMobile.vue?vue&type=script&lang=js&"
import style0 from "./bindMobile.vue?vue&type=style&index=0&id=a70c357a&prod&scoped=true&lang=css&"
import style1 from "./bindMobile.vue?vue&type=style&index=1&id=a70c357a&prod&scoped=true&lang=scss&"
import style2 from "./bindMobile.vue?vue&type=style&index=2&id=a70c357a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a70c357a",
  null
  
)

export default component.exports